(()=>{
function init(root){
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const canvas=root.querySelector('canvas'),c=canvas.getContext('2d'),scene=root.querySelector('.pv-pet-scene'),status=root.querySelector('[role=status]'),file=root.querySelector('[data-pet-file]'),undo=root.querySelector('[data-pet-undo]');
  const picker=root.querySelector('.pv-pet-picker'),pickImg=root.querySelector('[data-pick-img]'),pickRing=root.querySelector('[data-pick-ring]'),pickStage=root.querySelector('.pv-pet-picker__stage'),pickSize=root.querySelector('[data-pick-size]'),pickOk=root.querySelector('[data-pick-ok]'),pickCancel=root.querySelector('[data-pick-cancel]'),pickNote=root.querySelector('[data-pick-note]');
  const state={style:'renaissance',zoom:1,x:0,y:0,soft:8,tool:'move',head:false};
  const templates=new Map(),photo=document.createElement('canvas'),mask=document.createElement('canvas'),layer=document.createElement('canvas');
  photo.width=mask.width=layer.width=480;photo.height=mask.height=layer.height=720;
  let original=null,version=0,history=[],painting=false,cutPromise=null,pick={x:.5,y:.38,r:.26},currentFile=null;
  const ANCHOR={renaissance:{y:205,w:235},baroque:{y:230,w:245},antique:{y:230,w:245},viking:{y:212,w:225},western:{y:218,w:230},general:{y:172,w:215},victorian:{y:228,w:225},astronaut:{y:238,w:205}};
  const values=()=>{const a=ANCHOR[state.style]||{y:230,w:245};return{x:240+state.x*160,y:a.y+state.y*190,w:a.w*state.zoom,h:a.w*1.265*state.zoom};};
  function watermark(c){c.save();c.translate(240,360);c.rotate(-Math.PI/7);c.font='14px Arial';c.textAlign='center';for(let y=-480;y<650;y+=92)for(let x=-500;x<600;x+=290){c.fillStyle='#0005';c.fillText(root.dataset.watermark,x+1,y+1);c.fillStyle='#fff8';c.fillText(root.dataset.watermark,x,y);}c.restore();}
  function paint(c,hideMark){
    c.save();c.fillStyle='#302921';c.fillRect(0,0,480,720);
    const template=templates.get(state.style);if(template)c.drawImage(template,0,0,480,720);
    if(original&&state.head){
      const p=values(),lc=layer.getContext('2d');
      lc.clearRect(0,0,480,720);lc.save();
      lc.filter=state.style==='antique'?'sepia(.45) saturate(.6) contrast(1.06)':(state.style==='astronaut'?'saturate(.9) contrast(1.05)':(state.style==='viking'?'sepia(.1) saturate(.7) contrast(1.08) brightness(.95)':'sepia(.18) saturate(.8) contrast(1.04)'));
      lc.drawImage(photo,0,0);lc.restore();
      lc.globalCompositeOperation='destination-in';lc.drawImage(mask,0,0);lc.globalCompositeOperation='source-over';
      const feather=document.createElement('canvas');feather.width=480;feather.height=720;
      const fc=feather.getContext('2d');fc.translate(240,360);fc.scale(1,1.186);
      const g=fc.createRadialGradient(0,0,Math.max(6,236-state.soft*3.4),0,0,244);
      g.addColorStop(0,'#fff');g.addColorStop(1,'#fff0');
      fc.fillStyle=g;fc.fillRect(-240,-360,480,720);
      lc.globalCompositeOperation='destination-in';lc.drawImage(feather,0,0);lc.globalCompositeOperation='source-over';
      c.drawImage(layer,p.x-p.w/2,p.y-p.h/2,p.w,p.h);
    }else{
      c.fillStyle='#faf4e6';c.font='15px Georgia';c.textAlign='center';c.fillText(root.dataset.empty,240,230,330);
    }
    const name=root.querySelector('[data-pet-name]').value.trim();
    if(name){c.fillStyle='#f8f0dc';c.textAlign='center';c.font='18px Georgia';c.shadowColor='#000';c.shadowBlur=6;c.fillText(name,240,678,390);c.shadowBlur=0;}
    if(!hideMark)watermark(c);c.restore();
  }
  function render(){paint(c,false);}
  function exportTo(target,W,H){const t=target.getContext('2d');t.save();t.scale(W/480,H/720);paint(t,true);t.restore();}
  function reset(){const mc=mask.getContext('2d');mc.globalCompositeOperation='source-over';mc.clearRect(0,0,480,720);mc.fillStyle='#fff';mc.fillRect(0,0,480,720);history=[];undo.disabled=true;render();}
  root.querySelectorAll('[data-pet-style]').forEach(b=>{
    const img=new Image();img.crossOrigin='anonymous';
    img.onload=()=>{templates.set(b.dataset.petStyle,img);render();};
    img.onerror=()=>{status.textContent=root.dataset.templateError;};
    img.src=b.querySelector('img').src;
    b.onclick=()=>{state.style=b.dataset.petStyle;root.querySelectorAll('[data-pet-style]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render();};
  });
  async function cutout(f){
    if(root.dataset.cutout==='off')return null;
    try{
      const mod=await import('https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.5.8/+esm');
      const out=await mod.removeBackground(f,{output:{format:'image/png',quality:0.9}});
      return await createImageBitmap(out);
    }catch(e){return null;}
  }
  /* --- head picker --- */
  function ring(){
    const w=pickStage.clientWidth,h=pickStage.clientHeight;
    pickRing.style.left=(pick.x*w)+'px';
    pickRing.style.top=(pick.y*h)+'px';
    const d=pick.r*2*w;
    pickRing.style.width=d+'px';pickRing.style.height=(d*1.18)+'px';
  }
  function movePick(e){
    const r=pickStage.getBoundingClientRect();
    pick.x=Math.min(1,Math.max(0,(e.clientX-r.left)/r.width));
    pick.y=Math.min(1,Math.max(0,(e.clientY-r.top)/r.height));
    ring();
  }
  let dragging=false;
  pickStage.addEventListener('pointerdown',e=>{e.preventDefault();dragging=true;pickStage.setPointerCapture(e.pointerId);movePick(e);});
  pickStage.addEventListener('pointermove',e=>{if(dragging)movePick(e);});
  pickStage.addEventListener('pointerup',()=>dragging=false);
  pickStage.addEventListener('pointercancel',()=>dragging=false);
  pickSize.addEventListener('input',()=>{pick.r=Number(pickSize.value)/100;ring();});
  window.addEventListener('resize',()=>{if(!picker.hidden)ring();});
  function closePicker(){picker.hidden=true;document.body.style.overflow='';}
  pickCancel.onclick=()=>{closePicker();version++;currentFile=null;if(!state.head)status.textContent='';};
  pickOk.onclick=async()=>{
    const token=version,src=pickImg;
    pickOk.disabled=true;pickNote.textContent=root.dataset.cuttingText||root.dataset.loading;
    status.textContent=root.dataset.cuttingText||root.dataset.loading;
    let bmp=null;
    try{bmp=await cutPromise;}catch(e){bmp=null;}
    if(token!==version){pickOk.disabled=false;return;}
    const source=bmp||original;
    const sw=source.width||source.naturalWidth,sh=source.height||source.naturalHeight;
    const cx=pick.x*sw,cy=pick.y*sh,rad=pick.r*sw;
    const side=rad*2.25,sideH=side*1.18;
    const pc=photo.getContext('2d');
    pc.clearRect(0,0,480,720);
    const dw=480,dh=569,dy=360-dh/2;
    pc.drawImage(source,cx-side/2,cy-sideH/2,side,sideH,0,dy,dw,dh);
    state.head=true;state.zoom=1;state.x=state.y=0;
    root.querySelectorAll('[data-pet-control]').forEach(i=>{if(state[i.dataset.petControl]!==undefined&&i.dataset.petControl!=='soft')i.value=state[i.dataset.petControl];});
    reset();
    pickOk.disabled=false;pickNote.textContent='';
    closePicker();
    status.textContent=root.dataset.ready;
    const op=root.querySelector('[data-pv-order]');if(op&&op.pvRefresh)op.pvRefresh();
  };
  const busy=document.createElement('div');busy.className='pv-file-busy';busy.hidden=true;busy.innerHTML='<i></i><span></span>';
  const thumbs=document.createElement('div');thumbs.className='pv-file-thumbs';thumbs.hidden=true;
  if(file.parentNode&&file.parentNode.parentNode){file.parentNode.parentNode.insertBefore(thumbs,file.parentNode.nextSibling);file.parentNode.parentNode.insertBefore(busy,thumbs);}
  const openBtn=root.querySelector('[data-pet-reselect]');
  const showBusy=t=>{busy.hidden=false;busy.querySelector('span').textContent=t;};
  const hideBusy=()=>{busy.hidden=true;};
  const errBox=document.createElement('p');errBox.className='pv-pet-fileerr';errBox.hidden=true;
  if(file.parentNode&&file.parentNode.parentNode)file.parentNode.parentNode.insertBefore(errBox,file.parentNode.nextSibling);
  const showErr=t=>{errBox.textContent=t;errBox.hidden=false;};
  function downscale(im){
    const max=24000000;const px=im.width*im.height;
    if(px<=max)return im;
    const k=Math.sqrt(max/px),cv=document.createElement('canvas');
    cv.width=Math.round(im.width*k);cv.height=Math.round(im.height*k);
    cv.getContext('2d').drawImage(im,0,0,cv.width,cv.height);
    return cv;
  }
  function openPicker(url){
    pickImg.src=url;
    pick={x:.5,y:.38,r:.26};pickSize.value=26;
    picker.hidden=false;document.body.style.overflow='hidden';
    pickNote.textContent='';
    requestAnimationFrame(()=>requestAnimationFrame(ring));
  }
  let lastUrl=null;
  file.onchange=async()=>{
    const f=file.files[0];if(!f)return;
    const token=++version;
    errBox.hidden=true;
    if(f.size>60*1024*1024){hideBusy();showErr('That file is larger than 60 MB. Please choose a smaller image.');status.textContent=root.dataset.invalid;return;}
    status.textContent=root.dataset.loading;
    showBusy(root.dataset.loading);
    const url=URL.createObjectURL(f);
    thumbs.innerHTML='';const tim=new Image();tim.src=url;thumbs.appendChild(tim);thumbs.hidden=false;
    try{
      const im=new Image();im.src=url;await im.decode();
      if(token!==version){hideBusy();return;}
      original=downscale(im);currentFile=f;
      cutPromise=cutout(f);
      lastUrl=url;
      openPicker(url);
      hideBusy();
      if(openBtn)openBtn.hidden=false;
      status.textContent=root.dataset.pickHint||'';
    }catch(e){
      hideBusy();thumbs.hidden=true;
      showErr('We could not read that image. Try a JPG or PNG photo.');
      status.textContent=root.dataset.failed;
    }
  };
  root.querySelectorAll('[data-pet-control]').forEach(i=>i.oninput=()=>{state[i.dataset.petControl]=Number(i.value);render();});
  root.querySelector('[data-pet-name]').oninput=render;
  root.querySelectorAll('[data-pet-tool]').forEach(b=>b.onclick=()=>{
    state.tool=b.dataset.petTool;scene.dataset.tool=state.tool;
    root.querySelector('.pv-pet-eraser').hidden=state.tool!=='erase';
    root.querySelectorAll('[data-pet-tool]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
  });
  function erase(e){
    const r=canvas.getBoundingClientRect(),p=values(),x=((e.clientX-r.left)/r.width*480-(p.x-p.w/2))/p.w*480,y=((e.clientY-r.top)/r.height*720-(p.y-p.h/2))/p.h*720,mc=mask.getContext('2d');
    mc.globalCompositeOperation='destination-out';mc.beginPath();
    mc.ellipse(x,y,Number(root.querySelector('[data-pet-brush]').value)*480/p.w,Number(root.querySelector('[data-pet-brush]').value)*720/p.h,0,0,Math.PI*2);
    mc.fill();mc.globalCompositeOperation='source-over';render();
  }
  canvas.onpointerdown=e=>{if(state.tool!=='erase'||!state.head)return;e.preventDefault();history.push(mask.getContext('2d').getImageData(0,0,480,720));if(history.length>8)history.shift();undo.disabled=false;painting=true;canvas.setPointerCapture(e.pointerId);erase(e);};
  canvas.onpointermove=e=>{if(painting)erase(e);};
  canvas.onpointerup=canvas.onpointercancel=()=>painting=false;
  undo.onclick=()=>{const previous=history.pop();if(previous)mask.getContext('2d').putImageData(previous,0,0);undo.disabled=!history.length;render();};
  root.querySelector('[data-pet-reset]').onclick=reset;
  const reselect=root.querySelector('[data-pet-reselect]');
  if(reselect)reselect.hidden=true;
  if(reselect)reselect.onclick=()=>{if(!original){file.click();return;}picker.hidden=false;document.body.style.overflow='hidden';requestAnimationFrame(()=>requestAnimationFrame(ring));};
  scene.addEventListener('contextmenu',e=>e.preventDefault());
  scene.addEventListener('dragstart',e=>e.preventDefault());
  render();
  const op=root.querySelector('[data-pv-order]');
  if(op){
    const pvGo=()=>window.PVOrder&&window.PVOrder.mount(op,{tool:'pets',label:op.dataset.label,getSize:()=>op.dataset.size||'30x40',getFrame:()=>op.dataset.frame||'none',validate:()=>!!(original&&state.head),draw:(cx,w,h)=>{cx.save();cx.scale(w/480,h/720);paint(cx,true);cx.restore();},details:()=>({'Style':state.style,'Pet name':root.querySelector('[data-pet-name]').value.trim()})});
    if(window.PVOrder)pvGo();else document.addEventListener('pv-order:ready',pvGo,{once:true});
    root.addEventListener('input',()=>op.pvRefresh&&op.pvRefresh());
  }
}
document.querySelectorAll('.pv-pets').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.pv-pets').forEach(init));
})();

